<template>
  <div>
    <section-header :ressource="ressource"
                    :isExtended="extended"
                    :dialog="dialog"
                    :picto="picto()"
                    @closeDialog=closeDialog
                    ref="STATUS">
    </section-header>
    <div class="d-flex flex-row-reverse mt-4">
      <loader-button class="ms-2"
                     :label="laterLabel"
                     @callback="closeDialog">
      </loader-button>
      <loader-button class="ms-2"
                     :label="importLabel"
                     :disabled="hasStatus"
                     @callback="statusAction">
      </loader-button>
    </div>
    <section-container :dialogOpen="dialogOpen"
                       :extended="true"
                       :section="section"
                       @closeDialog="closeEditor">
    </section-container>
  </div>
</template>

<script lang="ts">
import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
import { ObjTypes } from '@/generated/classes/ObjTypes'
import Document from '@/generated/classes/Document'
import Etablissement from '@/generated/classes/Etablissement'
import LoaderButton from '@/framework/base/components/LoaderButton.vue';
import SectionContainer from '@/framework/base/components/SectionContainer.vue';
import SectionImportDoc from '@/custom/sections/SectionImportDoc.vue';
import Section from '@/framework/base/classes/Section';
import { storeDocument } from '@/generated/stores';
import { ListFilter } from '../../generated/classes/ListData';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  components: { 
    SectionHeader,
    LoaderButton,
    SectionContainer
  },
  props: {
    extended: {
      type: Boolean
    },
    dialog: {
      type: Boolean
    },
    hideTitle: {
      type: Boolean
    },
    etablissement: {
      type: Object as PropType<Etablissement>,
      required: true
    }
  },
  created() {
    storeDocument.registerDocument();
  },
  data() {
    return {
      dialogOpen: false
    };
  },
  computed: {
    importLabel() {
      return RessourceFwkButton(FwkButtons.IMPORTER).label;
    },
    laterLabel() {
      if (this.hasStatus) {
        return RessourceFwkButton(FwkButtons.FERMER).label;
      } else {
        return RessourceFwkButton(FwkButtons.RAPPELER).label;
      }
    },
    errorTxt() {
      return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
    },
    ressource() {
      return RessourceGenSection(GenSection.IMPORT_STATUS);
    },
    hasStatus(): boolean {
      return this.docStatus.fileName != '';
    },
    documentId(): number {
      let res = 0;
      const doc = storeDocument.listDocument.find(a => a.objType == ObjTypes.STATUS && a.objId == this.etablissement.id);
      if (doc) {
        res = doc.id;
      }
      return res;
    },
    docStatus(): Document {
      return storeDocument.getDocument(this.documentId);
    },
    section(): Section {
      const section = new Section();
      section.component = SectionImportDoc;
      section.type = 'document';
      section.data = this.docStatus;
      section.ressource = this.ressource;
      return section;
    }
  },

  methods: {
    picto(): string {
      return 'SectionPictoStatus'
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    statusAction() {
      this.dialogOpen = true;
    },
    closeEditor() {
      this.dialogOpen = false
    }
  }
})

</script>
